import React from 'react';
import { anos30Text, BRAZIL_MAP_URL, SELO_30_URL } from '../mock';

const Anos30 = () => {
  return (
    <section id="anos30" className="relative">
      {/* Map area - uses the full background image (map + textured wall) */}
      <div
        className="relative w-full overflow-hidden bg-cover"
        style={{
          backgroundImage: `url(${BRAZIL_MAP_URL})`,
          backgroundPosition: '28% center',
          minHeight: '600px',
        }}
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-16 py-24 grid grid-cols-1 lg:grid-cols-2 items-center gap-10 min-h-[600px]">
          {/* Empty left column lets the map (centered in image) show */}
          <div />

          <div className="text-left lg:text-right">
            <p className="text-[#C99A36] tracking-[0.4em] text-[12px] font-semibold mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              30 ANOS
            </p>
            <h2 className="text-[#1a1a1a] text-[34px] md:text-[48px] font-bold leading-[1.05] tracking-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              ATUAÇÃO EM<br />TODO TERRITÓRIO<br />NACIONAL!
            </h2>
            <div className="mt-6 w-24 h-[3px] bg-[#C99A36] lg:ml-auto" />
          </div>
        </div>
      </div>

      {/* Description with dark bg */}
      <div className="relative" style={{ background: 'linear-gradient(180deg, #0e0e0e 0%, #1c1c1c 100%)' }}>
        <div className="max-w-3xl mx-auto px-6 py-20 text-center">
          <div className="flex justify-center mb-10">
            <img
              src={SELO_30_URL}
              alt="30 anos - Técnica, confiança e impacto positivo"
              className="w-[200px] md:w-[240px] h-auto select-none"
              draggable={false}
            />
          </div>
          {anos30Text.map((p, i) => (
            <p
              key={i}
              className="text-white/90 leading-[1.9] text-[15px] tracking-wide text-justify mb-5"
              style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 300 }}
            >
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Anos30;
